import { Union, Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { obj_type, union_type, tuple_type, int64_type, class_type, array_type, option_type, int32_type, record_type, string_type, float64_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { uncurry2, defaultOf, equalArrays, int32ToString, createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { Alert_snackError, LoadingIndicator_skeleton } from "./Components/Components.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { Format_formatSpacedLong, Format_quoteToString } from "./Components/Utils.js";
import { op_Subtraction, fromFloat64, toFloat64, compare, fromInt32, equals, op_Addition, toInt64 } from "./fable_modules/fable-library-js.4.17.0/BigInt.js";
import { parse } from "./fable_modules/fable-library-js.4.17.0/Long.js";
import { append as append_1, item, equalsWith, map, sortByDescending, sumBy } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { format } from "./fable_modules/fable-library-js.4.17.0/String.js";
import { toString, compare as compare_1, parse as parse_1 } from "./fable_modules/fable-library-js.4.17.0/Date.js";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { toString as toString_1 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { DataServerBaseUrl } from "./Components/Constants.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { AssetBanner } from "./Components/Ads.js";

export class QuoteEntry extends Record {
    constructor(Close, Date$) {
        super();
        this.Close = Close;
        this.Date = Date$;
    }
}

export function QuoteEntry_$reflection() {
    return record_type("AssetTradingInfo.QuoteEntry", [], QuoteEntry, () => [["Close", float64_type], ["Date", string_type]]);
}

export class VolumeEntry extends Record {
    constructor(Volume, Date$) {
        super();
        this.Volume = Volume;
        this.Date = Date$;
    }
}

export function VolumeEntry_$reflection() {
    return record_type("AssetTradingInfo.VolumeEntry", [], VolumeEntry, () => [["Volume", string_type], ["Date", string_type]]);
}

export class Split extends Record {
    constructor(FactorBase, FactorChange, Date$) {
        super();
        this.FactorBase = (FactorBase | 0);
        this.FactorChange = (FactorChange | 0);
        this.Date = Date$;
    }
}

export function Split_$reflection() {
    return record_type("AssetTradingInfo.Split", [], Split, () => [["FactorBase", int32_type], ["FactorChange", int32_type], ["Date", string_type]]);
}

export class ShareChange extends Record {
    constructor(Diff, Date$) {
        super();
        this.Diff = Diff;
        this.Date = Date$;
    }
}

export function ShareChange_$reflection() {
    return record_type("AssetTradingInfo.ShareChange", [], ShareChange, () => [["Diff", string_type], ["Date", string_type]]);
}

export class TradingInfoSummary extends Record {
    constructor(HighestQuote, LowestQuote, HighestClose, LowestClose, HighestVolume, LowestVolume, Splits, ShareChanges, NumShares, SharesShort) {
        super();
        this.HighestQuote = HighestQuote;
        this.LowestQuote = LowestQuote;
        this.HighestClose = HighestClose;
        this.LowestClose = LowestClose;
        this.HighestVolume = HighestVolume;
        this.LowestVolume = LowestVolume;
        this.Splits = Splits;
        this.ShareChanges = ShareChanges;
        this.NumShares = NumShares;
        this.SharesShort = SharesShort;
    }
}

export function TradingInfoSummary_$reflection() {
    return record_type("AssetTradingInfo.TradingInfoSummary", [], TradingInfoSummary, () => [["HighestQuote", option_type(QuoteEntry_$reflection())], ["LowestQuote", option_type(QuoteEntry_$reflection())], ["HighestClose", option_type(QuoteEntry_$reflection())], ["LowestClose", option_type(QuoteEntry_$reflection())], ["HighestVolume", option_type(VolumeEntry_$reflection())], ["LowestVolume", option_type(VolumeEntry_$reflection())], ["Splits", array_type(Split_$reflection())], ["ShareChanges", array_type(ShareChange_$reflection())], ["NumShares", option_type(string_type)], ["SharesShort", option_type(string_type)]]);
}

function th$0027(hideSmall, title) {
    return createElement("th", createObj(toList(delay(() => append(hideSmall ? singleton(["className", "hide-small-screens"]) : empty(), delay(() => append(singleton(["style", {
        padding: ((((((6 + "px ") + 12) + "px ") + 6) + "px ") + 0) + "px",
    }]), delay(() => singleton(["children", title])))))))));
}

function td$0027(x, f) {
    let elems;
    return createElement("td", createObj(ofArray([["style", {
        padding: ((((((6 + "px ") + 12) + "px ") + 6) + "px ") + 8) + "px",
        color: "var(--text-main)",
        textAlign: "right",
    }], (elems = toList(delay(() => {
        if (x != null) {
            const matchValue = x;
            return (matchValue != null) ? singleton(f(matchValue)) : singleton("N/A");
        }
        else {
            return singleton(LoadingIndicator_skeleton(ofArray([["height", 22], ["width", 80], ["margin", "auto"]])));
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function sectionHeader(title) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 5,
    }], (elems = [createElement("h2", {
        style: {
            fontSize: 1.5 + "rem",
            fontWeight: 500,
            margin: 0,
        },
        children: title,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function drawFifthyTwoWeekQuote(ti) {
    let elems, children_14, children_12, children, children_2, children_4, children_6, children_8, children_10;
    return createElement("div", createObj(ofArray([["style", {
        maxWidth: 400,
        flexGrow: 1,
    }], (elems = [sectionHeader("Kurshistorikk (52 uker)"), (children_14 = singleton_1((children_12 = ofArray([(children = ofArray([th$0027(false, "52-ukers høy (intradag)"), td$0027(ti, (ti_1) => {
        const matchValue = ti_1.HighestQuote;
        return (matchValue != null) ? Format_quoteToString(matchValue.Close) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([th$0027(false, "52-ukers lav (intradag)"), td$0027(ti, (ti_2) => {
        const matchValue_1 = ti_2.LowestQuote;
        return (matchValue_1 != null) ? Format_quoteToString(matchValue_1.Close) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray([th$0027(false, "52-ukers høy (sluttkurs)"), td$0027(ti, (ti_3) => {
        const matchValue_2 = ti_3.HighestClose;
        return (matchValue_2 != null) ? Format_quoteToString(matchValue_2.Close) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    })), (children_6 = ofArray([th$0027(false, "52-ukers lav (sluttkurs)"), td$0027(ti, (ti_4) => {
        const matchValue_3 = ti_4.LowestClose;
        return (matchValue_3 != null) ? Format_quoteToString(matchValue_3.Close) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    })), (children_8 = ofArray([th$0027(false, "52-ukers høy volum"), td$0027(ti, (ti_5) => {
        const matchValue_4 = ti_5.HighestVolume;
        return (matchValue_4 != null) ? matchValue_4.Volume : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_8)),
    })), (children_10 = ofArray([th$0027(false, "52-ukers lav volum"), td$0027(ti, (ti_6) => {
        const matchValue_5 = ti_6.LowestVolume;
        return (matchValue_5 != null) ? matchValue_5.Volume : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_10)),
    }))]), createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_12)),
    }))), createElement("table", {
        children: Interop_reactApi.Children.toArray(Array.from(children_14)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function drawShareStatistics(ti) {
    let elems, children_10, children_8, children, children_2, children_4, children_6;
    return createElement("div", createObj(ofArray([["style", {
        maxWidth: 400,
        flexGrow: 1,
    }], (elems = [sectionHeader("Aksjestatistikk"), (children_10 = singleton_1((children_8 = ofArray([(children = ofArray([th$0027(false, "Antall aksjer"), td$0027(ti, (ti_1) => {
        const matchValue = ti_1.NumShares;
        return (matchValue != null) ? Format_formatSpacedLong(toInt64(parse(matchValue, 511, false, 64))) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([th$0027(false, "Antall aksjer short"), td$0027(ti, (ti_2) => {
        const matchValue_1 = ti_2.SharesShort;
        return (matchValue_1 != null) ? Format_formatSpacedLong(toInt64(parse(matchValue_1, 511, false, 64))) : "N/A";
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray([th$0027(false, "Endring i antall aksjer (52 uker)"), td$0027(ti, (ti_3) => {
        const change = (ti_3.ShareChanges.length > 0) ? sumBy((sc) => toInt64(parse(sc.Diff, 511, false, 64)), ti_3.ShareChanges, {
            GetZero: () => (0n),
            Add: (x, y) => toInt64(op_Addition(x, y)),
        }) : (0n);
        const desc = equals(change, toInt64(fromInt32(0))) ? "" : ((compare(change, toInt64(fromInt32(0))) > 0) ? " (utvannende)" : " (innvannende)");
        return `${(compare(change, toInt64(fromInt32(0))) > 0) ? "+" : ""}${Format_formatSpacedLong(change)}${desc}`;
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    })), (children_6 = ofArray([th$0027(false, "Antall spleis/splitt (52 uker)"), td$0027(ti, (ti_4) => int32ToString(ti_4.Splits.length))]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    }))]), createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_8)),
    }))), createElement("table", {
        children: Interop_reactApi.Children.toArray(Array.from(children_10)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

class ChangeHistory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ShareChange", "Split"];
    }
}

function ChangeHistory_$reflection() {
    return union_type("AssetTradingInfo.ChangeHistory", [], ChangeHistory, () => [[["Item", tuple_type(class_type("System.DateTime"), int64_type, option_type(int64_type), option_type(int64_type))]], [["Item", tuple_type(class_type("System.DateTime"), int32_type, int32_type, option_type(int64_type), option_type(int64_type))]]]);
}

function ChangeHistory__Date(this$) {
    if (this$.tag === 1) {
        return this$.fields[0][0];
    }
    else {
        return this$.fields[0][0];
    }
}

function ChangeHistory__ToDiff(this$) {
    if (this$.tag === 1) {
        const factorChange = this$.fields[0][2] | 0;
        const factorBase = this$.fields[0][1] | 0;
        if (factorBase > factorChange) {
            return `Spleis ${factorBase}:${factorChange}`;
        }
        else {
            return `Splitt ${factorBase}:${factorChange}`;
        }
    }
    else {
        const diff = this$.fields[0][1];
        return `${(compare(diff, toInt64(fromInt32(0))) > 0) ? "+" : ""}${Format_formatSpacedLong(diff)}`;
    }
}

function ChangeHistory__ToNewNumber(this$) {
    if (this$.tag === 1) {
        const newNumShares_1 = this$.fields[0][4];
        if (newNumShares_1 != null) {
            return Format_formatSpacedLong(newNumShares_1);
        }
        else {
            return "";
        }
    }
    else {
        const newNumShares = this$.fields[0][3];
        if (newNumShares != null) {
            return Format_formatSpacedLong(newNumShares);
        }
        else {
            return "";
        }
    }
}

function ChangeHistory__ToPercentageChange(this$) {
    if (this$.tag === 1) {
        return "--";
    }
    else {
        const prevNumShares = this$.fields[0][2];
        const newNumShares = this$.fields[0][3];
        let matchResult, nn, pn;
        if (prevNumShares != null) {
            if (newNumShares != null) {
                matchResult = 0;
                nn = newNumShares;
                pn = prevNumShares;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                try {
                    const change = ((toFloat64(pn) / toFloat64(nn)) - 1) * 100;
                    return `${(change > 0) ? "+" : ""}${format('{0:' + "0.00" + '}', change)}%`;
                }
                catch (matchValue_1) {
                    return "--";
                }
            default:
                return "--";
        }
    }
}

function ChangeHistory__ToEffect(this$) {
    if (this$.tag === 1) {
        return "Lik";
    }
    else {
        const diff = this$.fields[0][1];
        if (compare(diff, toInt64(fromInt32(0))) > 0) {
            return "Utvannende";
        }
        else if (compare(diff, toInt64(fromInt32(0))) < 0) {
            return "Innvannende";
        }
        else {
            return "";
        }
    }
}

function drawShareChanges(ti) {
    let elems;
    const td$0027_1 = (hideSmall, txt) => createElement("td", createObj(toList(delay(() => append(hideSmall ? singleton(["className", "hide-small-screens"]) : empty(), delay(() => append(singleton(["style", {
        padding: ((((((6 + "px ") + 12) + "px ") + 6) + "px ") + 0) + "px",
        color: "var(--text-main)",
        textAlign: "left",
    }]), delay(() => singleton(["children", txt])))))))));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        borderRadius: 5,
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        padding: 2 + "vw",
        gap: 2 + "vw",
    }], (elems = toList(delay(() => append(singleton(sectionHeader("Endring i antall utestående aksjer (52 uker)")), delay(() => {
        let value_24, children_8, children_2, children, children_6;
        const matchValue = ti;
        if (matchValue != null) {
            const t = matchValue;
            let numShares;
            const matchValue_1 = t.NumShares;
            if (matchValue_1 != null) {
                const ns = matchValue_1;
                try {
                    numShares = toInt64(parse(ns, 511, false, 64));
                }
                catch (matchValue_2) {
                    numShares = undefined;
                }
            }
            else {
                numShares = undefined;
            }
            if (t.ShareChanges.length === 0) {
                return singleton((value_24 = "Det er ikke gjort noen innvannende eller utvannende endringer i antall utestående aksjer de siste 52 uker.", createElement("p", {
                    children: [value_24],
                })));
            }
            else {
                let changes;
                const sorted = sortByDescending((tupledArg) => tupledArg[0], map((sc) => [parse_1(sc.Date), toInt64(parse(sc.Diff, 511, false, 64))], t.ShareChanges), {
                    Compare: compare_1,
                });
                const splits = map((s) => [parse_1(s.Date), s.FactorBase, s.FactorChange], t.Splits);
                const findPreSplits = (dt_2) => splits.filter((tupledArg_1) => (compare_1(tupledArg_1[0], dt_2) > 0));
                const buildSplits = (x_1_mut, output_mut, prevNumShares_mut) => {
                    buildSplits:
                    while (true) {
                        const x_1 = x_1_mut, output = output_mut, prevNumShares = prevNumShares_mut;
                        if (!equalsWith(equalArrays, x_1, defaultOf()) && (x_1.length === 0)) {
                            return [output, prevNumShares];
                        }
                        else if (!equalsWith(equalArrays, x_1, defaultOf()) && (x_1.length === 1)) {
                            const factorChange = item(0, x_1)[2] | 0;
                            const factorBase = item(0, x_1)[1] | 0;
                            const dt_3 = item(0, x_1)[0];
                            const newNumShares = (prevNumShares != null) ? toInt64(fromFloat64(toFloat64(prevNumShares) * (factorBase / factorChange))) : undefined;
                            return [append_1(output, [new ChangeHistory(1, [[dt_3, factorBase, factorChange, prevNumShares, newNumShares]])]), newNumShares];
                        }
                        else {
                            const y_3 = x_1;
                            const patternInput = item(0, y_3);
                            const fc = patternInput[2] | 0;
                            const fb = patternInput[1] | 0;
                            const newNumShares_1 = (prevNumShares != null) ? toInt64(fromFloat64(toFloat64(prevNumShares) * (fb / fc))) : undefined;
                            x_1_mut = y_3.slice(1, y_3.length);
                            output_mut = append_1(output, [new ChangeHistory(1, [[patternInput[0], fb, fc, prevNumShares, newNumShares_1]])]);
                            prevNumShares_mut = newNumShares_1;
                            continue buildSplits;
                        }
                        break;
                    }
                };
                const build = (x_4_mut, output_1_mut, prevNumShares_1_mut) => {
                    build:
                    while (true) {
                        const x_4 = x_4_mut, output_1 = output_1_mut, prevNumShares_1 = prevNumShares_1_mut;
                        if (!equalsWith(equalArrays, x_4, defaultOf()) && (x_4.length === 0)) {
                            return output_1;
                        }
                        else if (!equalsWith(equalArrays, x_4, defaultOf()) && (x_4.length === 1)) {
                            const dt_5 = item(0, x_4)[0];
                            const diff = item(0, x_4)[1];
                            const patternInput_1 = buildSplits((output_1.length > 0) ? [] : findPreSplits(dt_5), [], prevNumShares_1);
                            const preSplitNum = patternInput_1[1];
                            const newNumShares_2 = (preSplitNum == null) ? undefined : toInt64(op_Subtraction(preSplitNum, diff));
                            const patternInput_2 = buildSplits(splits.filter((tupledArg_2) => (compare_1(tupledArg_2[0], dt_5) <= 0)), [], newNumShares_2);
                            return append_1(output_1, append_1(append_1(patternInput_1[0], [new ChangeHistory(0, [[dt_5, diff, prevNumShares_1, newNumShares_2]])]), patternInput_2[0]));
                        }
                        else {
                            const y_6 = x_4;
                            const patternInput_3 = item(0, y_6);
                            const dt_6 = patternInput_3[0];
                            const diff_1 = patternInput_3[1];
                            const patternInput_4 = buildSplits((output_1.length > 0) ? [] : findPreSplits(dt_6), [], prevNumShares_1);
                            const preSplitNum_1 = patternInput_4[1];
                            const newNumShares_3 = (preSplitNum_1 == null) ? undefined : toInt64(op_Subtraction(preSplitNum_1, diff_1));
                            let patternInput_6;
                            const patternInput_5 = item(1, y_6);
                            patternInput_6 = buildSplits(splits.filter((tupledArg_3) => {
                                const d_2 = tupledArg_3[0];
                                if (compare_1(d_2, dt_6) <= 0) {
                                    return compare_1(d_2, patternInput_5[0]) >= 0;
                                }
                                else {
                                    return false;
                                }
                            }), [], newNumShares_3);
                            const out_1 = append_1(output_1, append_1(append_1(patternInput_4[0], [new ChangeHistory(0, [[dt_6, diff_1, prevNumShares_1, newNumShares_3]])]), patternInput_6[0]));
                            x_4_mut = y_6.slice(1, y_6.length);
                            output_1_mut = out_1;
                            prevNumShares_1_mut = patternInput_6[1];
                            continue build;
                        }
                        break;
                    }
                };
                changes = build(sorted, [], numShares);
                return append(singleton((children_8 = ofArray([(children_2 = singleton_1((children = ofArray([th$0027(false, "Dato"), th$0027(false, "Endring"), th$0027(true, "Antall før endring"), th$0027(false, "%"), th$0027(true, "Effekt")]), createElement("tr", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                }))), createElement("thead", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_2)),
                })), (children_6 = map((change_4) => {
                    const children_4 = ofArray([td$0027_1(false, toString(ChangeHistory__Date(change_4), "dd/MM/yy")), td$0027_1(false, ChangeHistory__ToDiff(change_4)), td$0027_1(true, ChangeHistory__ToNewNumber(change_4)), td$0027_1(false, ChangeHistory__ToPercentageChange(change_4)), td$0027_1(true, ChangeHistory__ToEffect(change_4))]);
                    return createElement("tr", {
                        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                    });
                }, changes), createElement("tbody", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_6)),
                }))]), createElement("table", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_8)),
                }))), delay(() => {
                    const sumChange = sumBy((x_7) => {
                        if (x_7.tag === 0) {
                            return x_7.fields[0][1];
                        }
                        else {
                            return toInt64(fromInt32(0));
                        }
                    }, changes, {
                        GetZero: () => (0n),
                        Add: (x_8, y_7) => toInt64(op_Addition(x_8, y_7)),
                    });
                    const desc = (compare(sumChange, toInt64(fromInt32(0))) > 0) ? (`Over de siste 52 ukene har antallet utestående aksjer økt med ${Format_formatSpacedLong(sumChange)}. Dette gir en utvannende effekt for aksjonærer dersom de ikke har opprettholdt sitt eierskap gjennom f.eks. å delta i utvannende emisjoner. Med forbehold om feil.`) : (`Over de siste 52 ukene har antallet utestående aksjer minket med ${Format_formatSpacedLong(sumChange)}. Dette gir en innvannende effekt for aksjonærer da verdier i selskapet fordeles over et mindre antall aksjer. Med forbehold om feil.`);
                    return singleton(createElement("p", {
                        style: {
                            textAlign: "left",
                        },
                        children: desc,
                    }));
                }));
            }
        }
        else {
            return singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["height", 50]])));
        }
    })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function TradingInfo(tradingInfoInputProps) {
    let elems_1, elems;
    const ticker = tradingInfoInputProps.ticker;
    const market = tradingInfoInputProps.market;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const tradingInfo = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const setErrMsg = patternInput_1[1];
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(TradingInfoSummary_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/quote/trading-info/${market}/${ticker}`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(TradingInfoSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 1) {
                    setErrMsg("Kunne ikke laste handelsinformasjon. Vennligst prøv igjen senere");
                    return Promise.resolve();
                }
                else {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return createElement("div", createObj(ofArray([["className", "default-gap"], ["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_1 = [Alert_snackError(patternInput_1[0], () => {
        setErrMsg(undefined);
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        backgroundColor: "#FFFFFF",
        borderRadius: 5,
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        padding: 2 + "vw",
        gap: 2 + "vw",
    }], (elems = [drawFifthyTwoWeekQuote(tradingInfo), drawShareStatistics(tradingInfo)], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement(AssetBanner, null), drawShareChanges(tradingInfo)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

